import { createLogic } from 'redux-logic'
import { map, catchError } from 'rxjs/operators'
import * as constants from '../constants'
import { throwError } from 'rxjs'
import User from '@engine/user'

export const getAllProjects = createLogic({
    type: constants.GET_ALL_PROJECTS.ACTION,
    processOptions: {
        successType: constants.GET_ALL_PROJECTS.FULFILLED,
        failType: constants.GET_ALL_PROJECTS.REJECTED
    },
    process({ http, getState }) {
        const state = getState()
        const createdUserGuid = User.selectors.user.entityUserGuid(state)

        return http
            .post('/comps/projects/query', { ...state.comps.comps.pagination, userId: createdUserGuid })
            .pipe(
                map(http.getBody),
                catchError(err => throwError(err))
            )
    }
})
